import React from "react";
import "./header.css";

const Header = () => {
  return (
    <>
      <div className="container">
        <div>Cripto Moeda</div>
        <div>Price</div>
        <div>Price</div>
        <div>Porcentage</div>
        <div>Market</div>
      </div>
    </>
  );
};

export default Header;
